<template>
  <v-row :class="rowClass" class="pt-5 mb-5">
    <v-progress-circular
        indeterminate
        color="red">
    </v-progress-circular>
  </v-row>
</template>

<script>
export default {
  name: "Loading",
  props: {
    rowClass: {
      type: String,
      default: 'justify-center pb-4',
    },
  },
};
</script>